import {Location, matchPath, matchRoutes, useLocation} from "react-router-dom";
import * as React from "react";
import {useQuery, useSubscription} from "@apollo/client";
import {GET_USER} from "../store/queries/GetUser";
import {useEffect, useState} from "react";
import {WALLET_UPDATED} from "../store/subscriptions/WalletUpdated";
import {GetUserQuery, User, WalletUpdatedSubscription, WalletUpdatedSubscriptionVariables} from "../gql/graphql";
import { wsSubscriptionClient } from "../store/StoreLink";
import {authModalRoutes, matchLocalizedRoutes, modalRoutes} from "./AppRoutes";
import {useTranslation} from "react-i18next";

interface RouteContextProviderState {
    previousLocation: Location;
    backgroundLocation: null | Location;
    setBackgroundLocation: (location: Location | null) => void;
    currentRouteIsProtectedRoute: boolean;
    setRouteState: (state: RouteContextInterface) => void;
}

interface RouteContextInterface extends RouteContextProviderState {
    authenticated: boolean | null;
    user: null | User;
}

export const RouteContext = React.createContext<RouteContextInterface>({
    previousLocation: {
        pathname: '/',
        state: null,
        hash: "",
        search: "",
        key: "initial"
    },
    authenticated: null,
    user: null,
    backgroundLocation: null,
    setBackgroundLocation: (location: Location | null) => {
    },
    setRouteState: (state: RouteContextInterface) => {
    },
    currentRouteIsProtectedRoute: false
});

const WalletUpdateSubscription = (props: { walletId: string }) => {
    useSubscription<WalletUpdatedSubscription, WalletUpdatedSubscriptionVariables>(
        WALLET_UPDATED,
        {variables: {walletId: props.walletId + '_WalletUpdated'}}
    );
    return (<></>);
}
export const RouteContextProvider = (props: { children: React.ReactNode }) => {
    const {loading, error, data} = useQuery<GetUserQuery>(GET_USER);
    const [authenticated, setAuthenticated] = React.useState<boolean | null>(!!data?.identity);
    const [user, setUser] = React.useState<User | null>(null);
    const location = useLocation();
    const {t} = useTranslation();
    const [isSsr, setIsSsr] = useState(true);
    
    
    useEffect(() => {setIsSsr(false);},[]);
    useEffect(() => {
        if (!(loading || error)) {

            if (data !== undefined && data !== null && data.identity !== null) {
                if (!authenticated)
                    if (wsSubscriptionClient.client != null) {
                        wsSubscriptionClient.close();
                        (wsSubscriptionClient as any).connect();
                    }
                setAuthenticated(true);
                setUser(data.identity as User);
            } else {
                setAuthenticated(false);
                setUser(null);

            }
        } else {
            setAuthenticated(null);
            setUser(null);
        }
    }, [loading, error, data]);

    const setBackgroundLocation = (location: Location | null) => {
        setState({...routeState, backgroundLocation: location});
    }

    const setRouteState = (state: RouteContextProviderState) => {
        setState({...state});
     
    }  

    const isModalRoute = matchLocalizedRoutes([...authModalRoutes,...modalRoutes],location,t) != null;
    const [routeState, setState] = React.useState<RouteContextProviderState>({
        backgroundLocation: isModalRoute?{
            pathname: '/',
            state: null,
            hash: "",
            search: "",
            key: "initial"
        }:null,
        setBackgroundLocation: setBackgroundLocation,
        previousLocation: {
            pathname: '/',
            state: null,
            hash: "",
            search: "",
            key: "initial"
        },
        currentRouteIsProtectedRoute: false,
        setRouteState: setRouteState
    });

    return (
        <RouteContext.Provider
            value={{...routeState, authenticated, user}}>
            {props.children}

            {authenticated && !isSsr && (
                <WalletUpdateSubscription walletId={user?.wallet.id as string}/>
            )}
        </RouteContext.Provider>)
}
